import React from 'react';
import ClientsSection from '../components/ClientsSection';

const Clients = () => (
  <div className="pt-20">
    <div className="container-custom mx-auto px-4 sm:px-6 lg:px-8 pt-10 text-center">
      <h1 className="text-3xl sm:text-4xl font-bold text-white">شركاء النجاح</h1>
      <p className="text-gray-400 mt-3">شركات تشرفنا بالعمل معها</p>
    </div>
    <ClientsSection />
  </div>
);

export default Clients;
